import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'

import * as Yup from 'yup'

import TitleBar from 'components/TitleBar'
import Content from 'components/Content'
import Card from 'components/Card'
import CardTitle from 'components/CardTitle'
import Input from 'components/Form/LabelInput'
import BtnBlue from 'components/Button/BtnBlue'
import Messages from 'components/Messages'
import Spinner from 'components/Spinner'
import CardBody from 'components/CardBody'
import BtnBox from 'components/Button/BtnBox'

import api from 'services/api/api'

import { setErrors } from 'utils'

const validation = yup => ({
    name: yup.string()
        .required('Campo obrigatório')
})

const NewCarousel = () => {
    const [messages, setMessages] = useState({ messages: [], alert: '' })

    const history = useHistory()

    const formik = useFormik({
      initialValues: { 
        name: ''
      },
      validationSchema: Yup.object(validation(Yup)),
      onSubmit: async () => {
        try {
          await api.post(`/carousels`, {
            ...formik.values
          })

          history.push('/carrosseis')
        } catch (error) {
          setMessages({ messages: setErrors(error), alert: 'alert-orange' })
        }
      }
    })

    return (
        <>
        <TitleBar label="Carrosséis" currentPage="" />

        <Content>
          <Card>
            <CardTitle title="Cadastrar"></CardTitle>

            <Content>
              <CardBody>
                <form onSubmit={formik.handleSubmit}>
                  <Messages formMessages={messages.messages} alert={messages.alert} />

                  <Input name="name" label="Nome" formik={formik} />

                  <BtnBox>
                    <BtnBlue type="submit" disabled={formik.isSubmitting}>
                      {formik.isSubmitting ? <Spinner /> : "Enviar"}
                    </BtnBlue>
                  </BtnBox>
                </form>
              </CardBody>
            </Content>
          </Card>
        </Content>
      </>
    )
}

export default NewCarousel